
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Fortuneronrentinpune() {



    const cardData =
    {
        keyword: 'Fortuner on Rent in Pune',
        heading: 'Vedant Travels: Fortuner on Rent in Pune',
        headingDescription: 'Vedant Travels offers the Fortuner on rent in Pune, a luxurious, high-performance SUV ideal for long trips, family vacations, or corporate travel. With its powerful engine, spacious interior, and stylish design, the Fortuner ensures a comfortable and smooth ride on both city roads and highways. Whether you are planning a road trip or simply need an elegant ride for an important occasion, the Fortuner offers a blend of comfort and style for your travel needs.',

        top: 'Top Places to Visit in Pune with Vedant Travels',

       "topPlaces": [
        {
            "title": "Shaniwar Wada",
            "description": "A historic fort that was once the residence of the Peshwa rulers, Shaniwar Wada is a must-visit for history enthusiasts. The fort features impressive Maratha architecture and offers an engaging light-and-sound show that brings its fascinating history to life."
        },
        {
            "title": "Aga Khan Palace",
            "description": "Built in 1892, the Aga Khan Palace is not only a beautiful structure but also a significant historical site. It was used as a prison during the freedom struggle, and Mahatma Gandhi and his associates were held here. The palace is surrounded by lush gardens, providing a peaceful atmosphere for reflection."
        },
        {
            "title": "Sinhagad Fort",
            "description": "Located 35 km from Pune, Sinhagad Fort is a popular destination for trekkers and history lovers. The fort offers stunning views of the surrounding valleys and is known for its role in Maratha history. It’s a great place for those seeking adventure and historical exploration."
        },
        {
            "title": "Osho Ashram",
            "description": "Situated in Koregaon Park, the Osho Ashram is a globally recognized meditation and spiritual retreat center. Visitors can participate in a variety of meditation sessions and spiritual workshops, making it an ideal spot for relaxation and inner peace."
        },
        {
            "title": "Raja Dinkar Kelkar Museum",
            "description": "The Raja Dinkar Kelkar Museum houses a vast collection of Indian artifacts, including sculptures, musical instruments, and daily-use items from different historical periods. It’s a fascinating stop for anyone interested in India’s cultural heritage."
        },
        {
            "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
            "description": "A beautiful Japanese-inspired garden located in Pune, this garden is perfect for a relaxing stroll. With lush greenery, vibrant flowers, and serene ponds, it offers a peaceful escape from the busy city life."
        },
        {
            "title": "Pashan Lake",
            "description": "Pashan Lake is a serene spot, perfect for nature lovers and birdwatching enthusiasts. Surrounded by lush greenery, it provides a quiet environment for photography, walks, and peaceful reflection."
        },
        {
            "title": "Bund Garden",
            "description": "Bund Garden is a riverside park ideal for a relaxing walk, boating, or picnicking. The tranquil atmosphere and natural beauty make it a lovely spot to unwind and enjoy time with family or friends."
        },
        {
            "title": "Saras Baug",
            "description": "Saras Baug is a popular temple complex in Pune, known for its beautiful Ganesha temple and peaceful gardens. It’s a great place to enjoy a leisurely walk, relax in the gardens, or simply seek spiritual solace."
        },
        {
            "title": "Fergusson College",
            "description": "One of Pune’s oldest and most prestigious educational institutions, Fergusson College is known for its colonial-era architecture and rich academic history. It’s a beautiful campus to explore, showcasing Pune’s educational legacy and architectural beauty."
        }
    ],
"services": [
    {
        "name": "Fortuner on Rent Pune",
        "description": "Vedant Travels offers Toyota Fortuner on rent in Pune, providing a luxury and comfortable ride for both local and outstation travel. Our well-maintained Fortuner vehicles ensure a premium journey."
    },
    {
        "name": "Fortuner Rent in Pune",
        "description": "Looking to rent a Toyota Fortuner in Pune? Vedant Travels provides reliable Fortuner rental services for local trips, outstation tours, and special events, ensuring a smooth and comfortable ride."
    },
    {
        "name": "Toyota Fortuner on Rent in Pune",
        "description": "Rent a Toyota Fortuner in Pune with Vedant Travels for a comfortable and luxurious ride. Whether you're heading to an event or an outstation trip, our Fortuner rentals offer premium comfort and style."
    },
    {
        "name": "Toyota Fortuner Rental in Pune",
        "description": "Vedant Travels offers Toyota Fortuner rentals in Pune, perfect for luxury travel. Our vehicles are ideal for corporate events, weddings, and long-distance travel."
    },
    {
        "name": "Toyota Fortuner Rental in Pune Airport",
        "description": "Need a Toyota Fortuner at Pune Airport? Vedant Travels offers airport pickup and drop services in a Fortuner, ensuring you travel in comfort as soon as you arrive."
    },
    {
        "name": "Toyota Fortuner Rental in Pune Airport Contact Number",
        "description": "For Toyota Fortuner rentals at Pune Airport, contact Vedant Travels at [contact number]. We offer timely and reliable rental services for your airport journey."
    },
    {
        "name": "Toyota Fortuner Hire for Corporate Events",
        "description": "Vedant Travels offers Toyota Fortuner hire for corporate events in Pune. Make a grand impression with our luxury Fortuner vehicles, ensuring your team or guests travel in style."
    },
    {
        "name": "Toyota Fortuner Hire for Corporate Events Near Me",
        "description": "Need a Toyota Fortuner for a corporate event near you in Pune? Vedant Travels provides reliable Fortuner hire services for business meetings, conferences, and corporate functions."
    },
    {
        "name": "Toyota Fortuner Hire for Wedding Function",
        "description": "Make your wedding day special with a Toyota Fortuner hire from Vedant Travels. Our luxury vehicle is perfect for bridal transportation or family rides to the wedding venue."
    },
    {
        "name": "Fortuner on Rent for Wedding",
        "description": "For your wedding, rent a Toyota Fortuner with Vedant Travels. Our premium vehicles provide a stylish and luxurious option for transporting the bride, groom, and family."
    },
    {
        "name": "Fortuner Rent for One Day",
        "description": "Rent a Toyota Fortuner for one day with Vedant Travels. Ideal for local trips or special events, our one-day rental service ensures you enjoy a luxurious ride without the hassle of long-term booking."
    },
    {
        "name": "Fortuner Hire in Pimpri Chinchwad",
        "description": "Looking to hire a Toyota Fortuner in Pimpri Chinchwad? Vedant Travels provides reliable and luxurious Fortuner rentals in Pimpri Chinchwad for all your travel needs."
    },
    {
        "name": "Fortuner on Rent for Outstation",
        "description": "Vedant Travels offers Toyota Fortuner on rent for outstation trips. Whether you're heading to Nashik, Shirdi, or any other destination, our Fortuner rentals ensure comfort and luxury for your long-distance journey."
    },
    {
        "name": "Fortuner Hire for Corporate Office",
        "description": "Need a Toyota Fortuner for your corporate office transport needs? Vedant Travels offers reliable and luxurious Fortuner rentals for business trips, client meetings, and office events."
    },
    {
        "name": "Fortuner on Rent in Pune Monthly",
        "description": "Looking for a monthly Toyota Fortuner rental in Pune? Vedant Travels offers long-term Fortuner rentals, ideal for corporate, personal, or family needs with competitive pricing."
    },
    {
        "name": "Fortuner on Rent for Outstation",
        "description": "Vedant Travels provides Toyota Fortuner rentals for outstation trips. Whether it’s a family vacation or a corporate trip, enjoy a luxurious and comfortable ride with our Fortuner vehicles."
    },
    {
        "name": "Fortuner Rent Per Km",
        "description": "Vedant Travels offers competitive Fortuner rental rates per km. Our pricing ensures you travel in luxury without worrying about excessive charges."
    },
    {
        "name": "Fortuner on Rent in Mumbai",
        "description": "Rent a Toyota Fortuner in Mumbai with Vedant Travels. We offer luxury vehicles for both local and outstation journeys, ensuring a smooth and premium travel experience."
    },
    {
        "name": "Fortuner on Rent Mumbai",
        "description": "For premium transportation in Mumbai, Vedant Travels provides Toyota Fortuner on rent. Our reliable and luxury Fortuner rentals are ideal for special events, corporate travel, or long-distance trips."
    },
    {
        "name": "Fortuner Car on Rent in Mumbai",
        "description": "Vedant Travels offers a Toyota Fortuner car on rent in Mumbai for local and outstation trips. Enjoy a comfortable and luxurious ride with our well-maintained vehicles."
    }
],


"tableData": [
    ["Fortuner on Rent Pune", "Fortuner Rent in Pune"],
    ["Toyota Fortuner on Rent in Pune", "Toyota Fortuner Rental in Pune"],
    ["Toyota Fortuner Rental in Pune Airport", "Toyota Fortuner Rental in Pune Airport Contact Number"],
    ["Toyota Fortuner Hire for Corporate Events", "Toyota Fortuner Hire for Corporate Events Near Me"],
    ["Toyota Fortuner Hire for Wedding Function", "Fortuner on Rent for Wedding"],
    ["Fortuner Rent for One Day", "Fortuner Hire in Pimpri Chinchwad"],
    ["Fortuner on Rent for Outstation", "Fortuner Hire for Corporate Office"],
    ["Fortuner on Rent in Pune Monthly", "Fortuner on Rent for Outstation"],
    ["Fortuner Rent Per Km", "Fortuner on Rent in Mumbai"],
    ["Fortuner on Rent Mumbai", "Fortuner Car on Rent in Mumbai"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand the importance of punctuality, especially when renting a luxury vehicle like the Fortuner. Whether it's a special occasion, a business trip, or a weekend getaway, we ensure that your vehicle is available on time for a hassle-free experience."
    },
    {
      "WhyChooseheading": "Luxury and Comfort in Every Ride",
      "WhyChoosedescription": "The Toyota Fortuner is the epitome of luxury, offering spacious seating, a premium interior, and superior comfort. Perfect for both short and long journeys, whether you're traveling alone, with family, or a group, the Fortuner guarantees a smooth and comfortable ride."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly trained and experienced in handling luxury vehicles like the Fortuner. They are well-versed in the best routes and ensure a safe, comfortable, and enjoyable ride. With their professionalism, you can relax and enjoy the journey without any stress."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "At Vedant Travels, we provide competitive rates for Fortuner on Rent in Pune. Our pricing is clear and transparent with no hidden charges, ensuring you get the best value for your money. We offer flexible payment options to suit your convenience."
    },
    {
      "WhyChooseheading": "Safe and Secure Journey",
      "WhyChoosedescription": "Your safety is our top priority. The Fortuner comes equipped with top-notch safety features, including airbags, ABS, and GPS tracking. Our well-maintained fleet ensures that you travel securely, whether it's a city trip or a long-distance journey."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Vedant Travels offers 24/7 availability for Fortuner rentals in Pune. Whether you need the vehicle during the day or late at night, our service is available to accommodate your schedule, making it easier for you to travel whenever needed."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking a Fortuner with Vedant Travels is simple and hassle-free. You can book online through our website or mobile app, or you can contact our customer service team for assistance. We prioritize making the booking process as smooth as possible."
    },
    {
      "WhyChooseheading": "Customizable Travel Packages",
      "WhyChoosedescription": "Whether you're booking the Fortuner for a corporate event, a family trip, or sightseeing, we offer customizable travel packages. Let us know your travel needs, and we'll tailor the service to provide the perfect experience for your journey."
    }
  ]
    }



    const faqData = [
        {
            id: 1,
            question: 'How can I rent a Fortuner in Pune?',
            answer: 'You can easily rent a Fortuner by booking online via our website or mobile app. Alternatively, you can reach out to our customer service team, who will assist you with the booking and provide all the necessary details.',
        },
        {
            id: 2,
            question: 'What is the seating capacity of the Fortuner?',
            answer: 'The Toyota Fortuner can comfortably accommodate up to 7 passengers, making it ideal for group trips, family vacations, or corporate events.',
        },
        {
            id: 3,
            question: 'Is the Fortuner suitable for long-distance travel?',
            answer: 'Yes, the Fortuner is perfect for long-distance journeys. Its robust build, comfortable seating, and powerful performance ensure a smooth ride for both city drives and extended trips to nearby destinations.',
        },
        {
            id: 4,
            question: 'What payment methods do you accept for Fortuner rentals?',
            answer: 'We accept a variety of payment methods, including cash, credit/debit cards, and online payments via our app. We aim to provide flexible and convenient payment options for all our customers.',
        },
        {
            id: 5,
            question: 'Can I rent a Fortuner for a one-way trip?',
            answer: 'Yes, we offer one-way rentals for the Fortuner. Just provide your travel details, and we’ll arrange the vehicle for your one-way trip to your desired destination.',
        },
        {
            id: 6,
            question: 'Are there any additional charges for renting the Fortuner?',
            answer: 'Any additional charges, such as fuel costs, tolls, or waiting charges, will be communicated to you upfront. We ensure transparent pricing with no hidden fees, so you can plan your trip without any surprises.',
        },
        {
            id: 7,
            question: 'Can I hire the Fortuner for sightseeing in Pune?',
            answer: 'Yes, the Fortuner is an excellent choice for sightseeing in Pune. We can provide customized sightseeing tours to popular attractions like Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, and more.',
        },
        {
            id: 8,
            question: 'What is the luggage capacity of the Fortuner?',
            answer: 'The Fortuner offers generous boot space to accommodate standard luggage. If you have specific luggage needs, feel free to inform us while booking, and we will ensure your requirements are met.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate Fortuner bookings?',
            answer: 'Yes, we offer Fortuner rentals for corporate events, business meetings, and team outings. Whether you need one vehicle or several, we can provide a luxurious and professional travel experience tailored to your business needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Fortuner rental in Pune?',
            answer: 'Vedant Travels is known for its high-quality service, well-maintained fleet, experienced drivers, and affordable rates. When you rent a Fortuner with us, you can expect a comfortable, safe, and luxurious journey.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rahul Mehta",
            title: "Corporate Traveler",
            quote: "I rented a Fortuner for a corporate event, and it was a great experience. The vehicle was spotless, the driver was professional, and the ride was incredibly smooth. Highly recommend Vedant Travels for luxury rentals!",
            rating: 5,
        },
        {
            name: "Ms. Priya Deshmukh",
            title: "Family Traveler",
            quote: "We rented the Fortuner for a family trip to Lonavala, and it was the best decision. The vehicle was spacious, comfortable, and the driver was friendly and courteous. The entire journey was fantastic, and I will definitely rent again.",
            rating: 5,
        },
    ];
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Fortuner On Rent in Pune",
  "image": "https://vedanttravels.in/assets/images/fortuner-on-rent-in-pune.jpg",
  "description": "Rent Toyota Fortuner in Pune with Vedant Travels for a powerful, stylish, and comfortable SUV experience. Perfect for family trips, corporate travel, and outstation journeys with professional chauffeurs.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/fortuner-on-rent-in-pune"
  }
};



     


    return (
        <div>
           
        <Helmet>
  <title>Fortuner On Rent in Pune | Powerful & Stylish SUV | Vedant Travels</title>
  <meta 
    name="description" 
    content="Rent Toyota Fortuner in Pune with Vedant Travels for a powerful, stylish, and comfortable SUV experience. Perfect for family trips, corporate travel, and outstation journeys with professional chauffeurs." 
  />
  <meta 
    name="keywords" 
    content="Fortuner On Rent in Pune, Rent Toyota Fortuner Pune, Luxury SUV Rental Pune, Fortuner Hire Pune, Vedant Travels Fortuner, SUV on Rent Pune, Outstation Fortuner Rental Pune, Corporate SUV Rental Pune, Family SUV Rental Pune, Chauffeur Driven Fortuner Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      

            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/73.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Fortuneronrentinpune;